import {addSystemMessage} from "./roleFormatters/formatSystemMessage.ts";
import {cacheLastMeaningfulMessage} from "./Utils.ts";
import {addFormattedUserMessage} from "./roleFormatters/formatUserMessage.ts";
import {addFormattedAssistantMessage} from "./roleFormatters/formatAssistantMessage.ts";
import {addFormattedToolMessage} from "./roleFormatters/formatToolMessage.ts";
import {formatSummaryForPrompt} from "../summaryUtils.ts";

export const formatMessages = async (trimmedMessages: any[], environment: string, systemMessage: string, provider: string, model: string, mode: string, isGatherContext: boolean, conversationSummary: string | null = null) => {
    const formattedMessages: any[] = [];

    // This is for tool calls where the LLM's message didn't get it added for some reason, but the tool response was returned
    const addIfFound = new Set();
    const processedToolCallIds = new Set<string>();

    // Find the index of the last user message so we can inject the summary there
    let lastUserMessageIndex = -1;
    if (conversationSummary) {
        for (let i = trimmedMessages.length - 1; i >= 0; i--) {
            if (trimmedMessages[i]?.message?.role === 'user' && !trimmedMessages[i]?.message?.isTemp) {
                lastUserMessageIndex = i;
                break;
            }
        }
    }

    let audioFilesSeen = 0;
    for (let i = 0; i < trimmedMessages.length; i++) {
        const currentNode = trimmedMessages[i];
        if (!currentNode || !currentNode.message || currentNode.message.isLoading) continue;

        const currentNodeCopy = structuredClone(currentNode);

        // Inject conversation summary as the very first thing in the last user message's prompt prefix
        if (conversationSummary && i === lastUserMessageIndex) {
            const formattedSummary = formatSummaryForPrompt(conversationSummary);
            currentNodeCopy.message.promptPrefix = formattedSummary + (currentNodeCopy.message.promptPrefix || '');
        }

        switch (currentNode.message.role) {
            case 'user':
                audioFilesSeen = await addFormattedUserMessage(formattedMessages, currentNodeCopy, model, audioFilesSeen, isGatherContext);
                break;
            case 'assistant':
                await addFormattedAssistantMessage(formattedMessages, trimmedMessages, i, currentNodeCopy, provider, model, addIfFound);
                break;
            case 'tool':
                await addFormattedToolMessage(formattedMessages, currentNodeCopy, provider, addIfFound, processedToolCallIds);
                break;
        }
    }


    const formattedAndCachedMessages = cacheLastMeaningfulMessage(formattedMessages, environment, mode, model);
    addSystemMessage(formattedAndCachedMessages, systemMessage, model);

    return formattedAndCachedMessages;
};
